module.exports = ".col-form-label {\n  font-size: 5px !important; }\n"